<div class="container">

  <section class='header'>

    <mat-toolbar color='primary' fxLayoutAlign="space-between">
      <div style="display: flex; flex-direction: row; align-items: center;">
        <mat-icon>person</mat-icon>
        <div style='margin-left:10px;'>
          Atualização
        </div>
      </div>

      <button class="button-close" mat-raised-button mat-dialog-close>
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar>

  </section>


  <div class="content">
    <p>
      <strong> {{ dataChanged.name }} </strong>
    </p>

    <div *ngFor="let item of dataChanged.changes">
      <div *ngFor="let field of item | keyvalue">
        <div *ngIf="field.key =='Currículo'">
           <div><b>{{ field.key }}:</b></div>
            Alterado de <div style="color:darkblue;" [innerHTML]="field.value.antes"></div>
            <br>       
            para <div style="color:darkblue;" [innerHTML]="field.value.depois"></div>
        </div>

        <div *ngIf="field.key !== 'Currículo'">
          <p>
            <strong>{{ field.key }}:</strong>
            Alterado de <span style="color:darkblue;"><b>{{ field.value.antes }}</b></span> para <span
              style="color:darkblue;"><b>{{ field.value.depois }}</b></span>
          </p>
        </div>

      </div>
    </div>

  </div>



</div>